import { group as actions } from '../actions'
import * as R from 'ramda'

// Reducers for
// store/action-methods/modal.js
export const reducer = {}

reducer[actions.SET_GROUPS] = ({ state, action }) =>
  R.mergeRight(state.group, action.data)

reducer[actions.SET_EDITORS] = ({ state, action }) => ({
  editors: R.mergeDeepRight(state.editors, action.editors)
})

reducer[actions.UPDATE_EDITORS] = ({ state, action }) => ({
  editors: action.updateFn(state.editors)
})
